import {useMemo} from 'react';

import {matchUrl} from './match-url';
import {useAppRouter} from './router-context';
import {RouteName} from './table';

export type CurrentRoute = {
	/** имя текущего маршрута или null, если адрес не разобран */
	routeName: RouteName | null;
	/** параметры, вынутые из самого адреса */
	params: Record<string, string>;
	/** параметры адреса вместе с query-строкой */
	query: Record<string, string | string[] | undefined>;
	/** текущий адрес как он есть в строке браузера */
	asPath: string;
};

/**
 * Текущий маршрут, разобранный по таблице ROUTES.
 *
 * Сопоставление идёт по asPath, поэтому работает одинаково на сервере и в браузере
 * и не зависит от того, какая страница Next фактически отрисовывает адрес.
 */
export function useRoute(): CurrentRoute {
	const router = useAppRouter();
	const asPath = router?.asPath || '';
	const routerQuery = router?.query;

	return useMemo(() => {
		const matched = matchUrl(asPath);
		return {
			routeName: matched?.name ?? null,
			params: matched?.params ?? {},
			query: {...(routerQuery || {}), ...(matched?.params || {})},
			asPath,
		};
	}, [asPath, routerQuery]);
}
